import { P2GGrid } from '@parcel2go/core-ui';
import { ReactNode } from 'react';

interface props {
  left: ReactNode;
  right: ReactNode;
  width: number;
  alignment?: 'left' | 'right';
  spacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
  alignContent?: 'stretch' | 'center' | 'flex-start' | 'flex-end' | 'space-between' | 'space-around';
  alignItems?: 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline';
}

const FixedColumn: React.FC<props> = (props) => {
  return props.alignment === 'right' ? (
    <P2GGrid
      container
      wrap="nowrap"
      alignContent={props.alignContent}
      gap={props.spacing}
      alignItems={props.alignItems}
    >
      <P2GGrid item flexGrow={1} zeroMinWidth>
        <div>{props.left}</div>
      </P2GGrid>
      <P2GGrid item flexShrink={1}>
        <div style={{ width: props.width }}>{props.right}</div>
      </P2GGrid>
    </P2GGrid>
  ) : (
    <P2GGrid
      container
      wrap="nowrap"
      alignContent={props.alignContent}
      gap={props.spacing}
      alignItems={props.alignItems}
    >
      <P2GGrid item flexShrink={1}>
        <div style={{ width: props.width, overflow: 'hidden' }}>{props.left}</div>
      </P2GGrid>
      <P2GGrid item flexGrow={1} zeroMinWidth>
        {props.right}
      </P2GGrid>
    </P2GGrid>
  );
};

export { FixedColumn };
